module.exports = __webpack_public_path__ + "img/18_Willing Risk Taker.392ebc60.svg";